// src/pages/FAQ/FAQ.jsx
import React, { useState } from "react";
import MainLayout from "../../components/Layout/MainLayout";
import { faqItems } from "./faqData";
import { faq, tutorial } from "../../styles/theme"; // include tutorial styles for this section

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <MainLayout>
      <section style={faq.section}>
        <h1 style={faq.title}>Frequently Asked Questions</h1>

        <div style={faq.container}>
          {faqItems.map((item, idx) => (
            <div key={idx} style={faq.card}>
              <button
                style={faq.question}
                onClick={() => toggleAnswer(idx)}
              >
                {item.question}
              </button>
            {openIndex === idx && (
            <p
                style={faq.answer}
                dangerouslySetInnerHTML={{ __html: item.answer }}
            />
            )}
            </div>
          ))}
        </div>

        {/* =========================
            Support & Contact Section
        ========================== */}
        <hr style={{ margin: "50px 0" }} />

        <section style={faq.supportSection}>
          <h3 style={tutorial.subTitle}>Support & Contact</h3>

          <p>
            For any technical issues with PathoTrack (e.g., job failures, BaseSpace connection errors, or missing notifications), 
            please reach out to the system administrator for assistance.
          </p>
          <p>
            <strong>Technical Support:</strong> <a href="mailto:zl7w2@missouri.edu">zl7w2@missouri.edu</a>
          </p>
          <p>
            <strong>Official / Administrative Contact:</strong> <a href="mailto:joshitr@health.missouri.edu">joshitr@health.missouri.edu</a>
          </p>
        </section>

      </section>
    </MainLayout>

  );
};

export default FAQ;